"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var lodash_1 = require("lodash");
var Entity_1 = require("../../Core/Entity");
var StoreEntity_1 = __importDefault(require("../../Core/StoreEntity"));
var Vehicle_consts_1 = require("../Vehicle.consts");
exports.Routes = {
    GET_ASSIGNMENT_HISTORY: '/vehicles/get_assignment_history/',
    GET_BY_TEAM: '/teams/{:teamId}/vehicles',
    IMPORT_VEHICLES_CSV: '/vehicles/import_from_csv',
    GET_CSV_UPLOAD_FIELDS: '/vehicles/csv_upload_fields',
    BATCH_UPDATE: '/vehicles/batch_update',
    PAGED_VEHICLES: '/vehicles/get_all_v2'
};
var VehicleEntity = /** @class */ (function (_super) {
    __extends(VehicleEntity, _super);
    function VehicleEntity(session) {
        var _this = _super.call(this, {
            session: session,
            entityName: 'vehicles',
            routes: [Entity_1.BaseRoutes.GetAll, Entity_1.BaseRoutes.Get, Entity_1.BaseRoutes.Delete, Entity_1.BaseRoutes.Update, Entity_1.BaseRoutes.Create]
        }) || this;
        _this.onVehicleUnassignedEvent = lodash_1.noop;
        _this.onVehicleUnassigned = function (fn) {
            _this.onVehicleUnassignedEvent = fn;
        };
        _this.importVehiclesCsv = function (file) {
            var formData = new FormData();
            formData.append('file', file);
            return _this.service.routeGenerator
                .post(exports.Routes.IMPORT_VEHICLES_CSV)
                .withHeaders({ 'Content-Type': 'multipart/form-data' })
                .withPayload(formData)
                .invoke();
        };
        _this.vehiclesByTeam = new Map();
        _this.subscribeToRealtime();
        return _this;
    }
    VehicleEntity.prototype.subscribeToRealtime = function () {
        var _this = this;
        this.realTime.on(Vehicle_consts_1.REAL_TIME_EVENTS.VEHICLE_UNASSIGNED, function (event) {
            return _this.onVehicleUnassignedEvent({
                user_id: event.user_id,
                vehicle_id: event.vehicle_id
            });
        });
        this.realTime.on(Vehicle_consts_1.REAL_TIME_EVENTS.VEHICLE_UPDATE, function (vehicle) { return _this.store.updateInStore(vehicle); });
    };
    VehicleEntity.prototype.getAll = function () {
        return this.getAllOrFetch(null, Vehicle_consts_1.vehiclesExtractor, Vehicle_consts_1.vehiclesExtractor);
    };
    VehicleEntity.prototype.getAllByTeam = function (teamId) {
        return __awaiter(this, void 0, void 0, function () {
            var vehicles;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.vehiclesByTeam.has(teamId)) {
                            return [2 /*return*/, this.vehiclesByTeam.get(teamId).map(function (vehicleId) { return _this.store.getItem(vehicleId); })];
                        }
                        return [4 /*yield*/, this.service.routeGenerator
                                .get(exports.Routes.GET_BY_TEAM)
                                .withExtractor(Vehicle_consts_1.vehiclesExtractor)
                                .setException("failed to get vehicles by team: ".concat(teamId))
                                .withRouteParams({ teamId: teamId })
                                .invoke()];
                    case 1:
                        vehicles = _a.sent();
                        vehicles.forEach(function (vehicle) { return _this.store.addToStore(vehicle); });
                        this.vehiclesByTeam.set(teamId, vehicles.map(function (vehicle) { return vehicle.id; }));
                        return [2 /*return*/, vehicles];
                }
            });
        });
    };
    VehicleEntity.prototype.get = function (id) {
        return this.getOrFetch(id, Vehicle_consts_1.vehicleExtractor, Vehicle_consts_1.vehicleExtractor);
    };
    VehicleEntity.prototype.getAssignmentHistory = function (vehicle_id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .post(exports.Routes.GET_ASSIGNMENT_HISTORY)
                        .withExtractor(Vehicle_consts_1.assignmentHistoryExtractor)
                        .setException("failed to get vehicle_Id: ".concat(vehicle_id, " assignment history"))
                        .withPayload({ vehicle_id: vehicle_id })
                        .invoke()];
            });
        });
    };
    VehicleEntity.prototype.getCsvUploadFields = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(exports.Routes.GET_CSV_UPLOAD_FIELDS)
                        .withExtractor(Vehicle_consts_1.getCsvFieldsExtractor)
                        .setException('failed to get vehicles csv upload fields')
                        .invoke()];
            });
        });
    };
    return VehicleEntity;
}(StoreEntity_1.default));
exports.default = VehicleEntity;
//# sourceMappingURL=VehicleEntity.js.map